require('./bootstrap');

window.select2 = require('select2');
window.Swal = require('sweetalert2');
import Chart from 'chart.js/auto';
window.Chart = Chart;
